import React, { useState, useEffect } from "react";
import { Tabs, Tab } from "@appkit4/react-components/tabs";
import BusinessImpactAnalysis from "./businessImpact";
import "../../../../styles/userManagement.css";
import {
  UpdateBusinessAnalsys
} from "../../../../services/ApiService";
import displayToastMessage from "../../../Common/Alert/displayToastMessage";
import APIService from "../../../../services/apiAxiosService";
import useHttp from "../../../../hooks/useHttp";
function BusinessImpact() {
  const [currentTab, setCurrentTab] = useState("1");
  const [businesssAnalysis, setBusinesssAnalysis] = useState([]);
  const [allClassifications, setAllClassifications] = useState([]);
  const [allVendorList, setAllVendorList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [updateBusinessAnalysis, setUpdateBusinessAnalysis] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [businessUsers, setBusinessUsers] = useState([]);
  const { sendRequest: getAllVendorList } = useHttp();
  const { sendRequest: getAllBUUsersList } = useHttp();
  const { sendRequest: getAllClassifications } = useHttp();
  const { sendRequest: getBusinessImpactAnalysis } = useHttp();
  const { sendRequest: getBusinessImpactByID } = useHttp();
  const { sendRequest: deleteRiskRequestByID } = useHttp();
  useEffect(() => {
    getBusinessListData();
    getAllVendorListData();
    getAllClassificationsData();
    getAllBUUsers();
  }, []);
  const getAllBUUsers = async () => {
    getAllBUUsersList(APIService.getAllBUUsersList(), (data) => {
      setBusinessUsers(data.MSG);
    })
  };
  const getBusinessListData = async () => {
    getBusinessImpactAnalysis(APIService.getBusinessImpactAnalysis(), (data) => {
      data.MSG.forEach(function (a) {
        a.expiray_date = a.expiray_date.substring(0, 10);
        a.date_issued = a.date_issued.substring(0, 10);
      });
      setBusinesssAnalysis(data.MSG);
    })
  };
  const getAllVendorListData = async () => {
    getAllVendorList(APIService.getAllVendorList(), (result) => {
      setAllVendorList(result.MSG)
    })
  };
  const getAllClassificationsData = async () => {
    getAllClassifications(APIService.getAllClassifications(), (data) => {
      setAllClassifications(data.MSG);
    })
  };

  const handleTabs = (e, v) => {
    setCurrentTab(v);
    setUpdateBusinessAnalysis({});
  };
  const handleDelete = async (AnalysisId, setmodalVisible) => {
    setLoading(true);
    try {
      deleteRiskRequestByID(APIService.deleteRiskRequestByID(AnalysisId), (result) => {
        if (result.CODE) {
          setLoading(false);
          displayToastMessage(result.MSG, "success");
          getBusinessListData();
          setmodalVisible(false);
        } else {
          setLoading(false);
          displayToastMessage("Something went wrong!", "error");
          setmodalVisible(false);
        }
      })
    } catch (error) {
      setLoading(false);
      displayToastMessage("Something went wrong!", "error");
      setmodalVisible(false);
    }
  };
  const updateBusinessAnalsys = async (data) => {
    setLoading(true);
    await UpdateBusinessAnalsys(data)
      .then((result) => {
        if (result.CODE) {
          displayToastMessage(result.MSG, "success");
          getBusinessListData();
          setLoading(false);
        } else {
          setLoading(false);
          displayToastMessage(
            "Something went wrong, Please try again!",
            "error"
          );
        }
      })
      .catch((err) => {
        setLoading(false);
        displayToastMessage("Something went wrong, Please try again!", "error");
      });
  };
  
  const getBusinessAnalysis = async (id) => {
    getBusinessImpactByID(APIService.getBusinessImpactByID(id), (result) => {
      setUpdateBusinessAnalysis(result.MSG[0]);
    })
  };

  return (
    <div className="user-management-container">
      <Tabs
        defaultValue={currentTab}
        value={currentTab}
        onChange={handleTabs}
        className="a-tab-item-padding-10"
      >
        <Tab value="1" label="Business Impact Analysis">
          <BusinessImpactAnalysis
            BusinesssAnalysis={businesssAnalysis}
            handleDelete={handleDelete}
            updateBusinessAnalsys={updateBusinessAnalsys}
            getBusinessAnalysis={getBusinessAnalysis}
            updateBusinessAnalysis={updateBusinessAnalysis}
            getBusinessListData={getBusinessListData}
            SetEditMode={setEditMode}
            EditMode={editMode}
            loading={loading}
            allVendorList={allVendorList}
            allClassifications={allClassifications}
            businessUsers={businessUsers}
          />
        </Tab>
      </Tabs>
    </div>
  );
}

export default BusinessImpact;
